import ApiService from "./ApiService";

export default class SurveyService extends ApiService
{
    collection = 'surveys'
}